import * as React from "react";
import { SVGProps } from "react";

const WarningIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    viewBox="0 0 64 64"
    fill="none"
    {...props}
  >
    <path
      fill="#F0B02A"
      d="M32 39.333c-1.093 0-2-.906-2-2V24c0-1.093.907-2 2-2s2 .907 2 2v13.333c0 1.094-.907 2-2 2ZM32 48c-.16 0-.346-.026-.533-.053-.16-.027-.32-.08-.48-.16a2.017 2.017 0 0 1-.48-.24l-.4-.32a2.804 2.804 0 0 1-.773-1.893c0-.694.293-1.387.773-1.894l.4-.32c.16-.106.32-.186.48-.24.16-.08.32-.133.48-.16.347-.08.72-.08 1.04 0 .187.027.347.08.507.16.16.053.32.133.48.24l.4.32c.48.507.773 1.2.773 1.894 0 .693-.293 1.386-.773 1.893l-.4.32c-.16.107-.32.187-.48.24-.16.08-.32.133-.507.16-.16.026-.346.053-.506.053Z"
    />
    <path
      fill="#F0B02A"
      d="M48.16 59.093H15.84c-5.2 0-9.173-1.893-11.2-5.307-2-3.413-1.733-7.813.8-12.373L21.6 12.346c2.667-4.8 6.347-7.44 10.4-7.44s7.733 2.64 10.4 7.44L58.56 41.44c2.533 4.56 2.827 8.933.8 12.373-2.027 3.387-6 5.28-11.2 5.28ZM32 8.906c-2.507 0-4.96 1.92-6.907 5.387L8.96 43.386c-1.813 3.254-2.107 6.24-.853 8.4 1.253 2.16 4.026 3.334 7.76 3.334h32.32c3.733 0 6.48-1.174 7.76-3.334 1.28-2.16.96-5.12-.854-8.4L38.907 14.293c-1.947-3.467-4.4-5.387-6.907-5.387Z"
    />
  </svg>
);
export default WarningIcon;
